// WhoThisIsFor.js
import React from 'react';
import { motion } from 'framer-motion';
import { Users, Briefcase, Globe } from 'lucide-react';

const WhoThisIsFor = () => {
  const audiences = [
    {
      icon: Users,
      title: 'Care and Healthcare Support Staff',
      description: 'People already working in care or healthcare support who want to take that experience overseas'
    },
    {
      icon: Briefcase,
      title: 'Skilled and Semi-Skilled Workers',
      description: 'Those holding qualifications and hands-on experience in their trade or profession'
    },
    {
      icon: Globe,
      title: 'People Ready to Relocate',
      description: 'Anyone prepared to move abroad and take up employment there'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-start">
          {/* Left Column - Heading */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl md:text-4xl font-semibold text-primary mb-6">
              Who We Work With
            </h2>
          </motion.div>

          {/* Right Column - Audience List */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="space-y-6"
          >
            {audiences.map((audience, index) => {
              const Icon = audience.icon;
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.3 + (index * 0.1) }}
                  className="flex items-start gap-4"
                >
                  <div className="flex-shrink-0 w-12 h-12 bg-surface rounded-lg flex items-center justify-center">
                    <Icon size={24} className="text-primary" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-primary mb-2">
                      {audience.title}
                    </h3>
                    <p className="text-gray-600 text-sm font-light">
                      {audience.description}
                    </p>
                  </div>
                </motion.div>
              );
            })}

            {/* Eligibility Note */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: 0.6 }}
              className="mt-8 p-6 bg-surface rounded-lg"
            >
              <p className="text-gray-700 text-sm font-normal italic">
                Some applicants will not meet the criteria. We check this at the consultation stage, so that anyone we take forward genuinely matches what employers are asking for.
              </p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhoThisIsFor;
